import React, { memo } from 'react'

import { string, bool, number } from 'prop-types'

import AutoGeneratedBadge from './Components/AutoGeneratedBadge/AutoGeneratedBadge'

function ThumbImageSlide({ src = null, isAutoGenerated = false, index }) {
  return (
    <>
      <img
        alt=""
        src={src}
        // Fixed size of the ItemImageUploader :thumb version (resize_to_fill 100x75).
        width="100"
        height="75"
        loading="lazy"
        decoding="async"
        className="gallery-area-thumbs-carousel__image-thumbnail"
      />
      {isAutoGenerated && <AutoGeneratedBadge index={index} />}
    </>
  )
}

ThumbImageSlide.propTypes = {
  src: string,
  isAutoGenerated: bool,
  index: number.isRequired,
}

export default memo(ThumbImageSlide)
